// require('./bootstrap');
import 'bootstrap'

import { createApp } from 'vue';
import App from './App.vue';
import { VueClipboard } from '@soerenmartius/vue3-clipboard';
import Toaster from '@meforma/vue-toaster';

// BEGIN: Font Awesome library
import { library } from '@fortawesome/fontawesome-svg-core'

//Font Awesome Icon styles
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { dom } from '@fortawesome/fontawesome-svg-core'

dom.watch() // This will kick of the initial replacement of i to svg tags and configure a MutationObserver
// END: Font Awesome library

library.add(fas, far)

createApp(App)
    .use(VueClipboard, Toaster)
    .mount('#app')
